/**
 * Filters Section Loading State Component
 *
 * Shows loading skeleton pills while agent is streaming or search is active.
 * Figma: /results-page-loading, Selected Filters and Sort Container (Node: 895:21282)
 *
 * This component displays the loading state seen in the Figma design:
 * - 2 gray loading pills in active filters section (NO LABEL during loading)
 * - 4 gray loading pills in SUGGESTED section (with SUGGESTED label)
 *
 * This component REPLACES ResultsFacetContainer during loading.
 * Once loading completes, ResultsFacetContainer takes over with actual data.
 */
"use client";

import { colors } from "@/styles/design-tokens";

import { AppliedFiltersLabel } from "./AppliedFiltersLabel";
import { FacetButton } from "./FacetButton";

export function FiltersSectionLoading() {
  return (
    <div
      className="flex flex-col items-start"
      style={{
        gap: "13px", // Gap between filter sections - from Figma parent
        width: "100%",
        maxWidth: "100%",
      }}
    >
      {/* Active Filters Section (NO LABEL during loading - Figma Node: 895:21290) */}
      <div
        className="flex w-full flex-col items-start"
        style={{
          borderBottom: `0.67px solid ${colors.divider.light}`,
          paddingTop: "10.49px",
          paddingBottom: "0.67px",
          gap: "6.99px",
          height: "68.49px",
        }}
      >
        {/* Filter Pills Row - 2 loading pills (80px × 24px each), NO label */}
        <div
          className="flex w-full flex-wrap items-start overflow-clip"
          style={{
            gap: "5.246px",
            opacity: 0.8,
          }}
        >
          <FacetButton variant="loading" label="" />
          <FacetButton variant="loading" label="" />
        </div>
      </div>

      {/* Suggested Filters Section (Figma Node: 895:21306) */}
      <div
        className="flex w-full flex-col items-start"
        style={{
          paddingTop: "10.49px",
          paddingBottom: "0.67px",
          gap: "6.99px",
          height: "68.49px",
        }}
      >
        {/* SUGGESTED label */}
        <div className="flex w-full items-center justify-between">
          <AppliedFiltersLabel label="SUGGESTED" state="no-expand" />
        </div>

        {/* 4 loading pills (80px × 24px each) */}
        <div
          className="flex w-full flex-wrap items-start overflow-clip"
          style={{
            gap: "5.246px",
            opacity: 0.8,
          }}
        >
          <FacetButton variant="loading" label="" />
          <FacetButton variant="loading" label="" />
          <FacetButton variant="loading" label="" />
          <FacetButton variant="loading" label="" />
        </div>
      </div>
    </div>
  );
}
